import { useContext, useEffect, useState } from 'react';
import { LoaderContext } from '../../../shared/context/loaderContext';
import { NotificationContext } from '../../../shared/context/notificationContext';
import { useCm360Api } from '../../../shared/const/api-backend';
import { CONFIG_TABLE } from '../../../shared/const/app.config';
import { UserDataContext } from 'shared/context/userDataContext';
import { reportError } from 'shared/services/raygunService';
import { differenceInDays, startOfDay } from 'date-fns';

const useFetchRefundsData = () => {
  const { selectedBusinessUnit, selectedBrand, sessionContext } =
    useContext(UserDataContext);
  const { setLoading } = useContext(LoaderContext);
  const { showNotification } = useContext(NotificationContext);
  const [data, setData] = useState([]);
  const API = useCm360Api();

  const calculateDaysRemaining = (refundDueDate) => {
    if (!refundDueDate) return null;

    const today = startOfDay(new Date());
    const dueDate = startOfDay(new Date(refundDueDate));

    const diffDays = differenceInDays(dueDate, today);

    return diffDays;
  };

  const fetchData = async (policyId) => {
    setLoading(true);
    try {
      let apiUrl = `refunds?offset=0&limit=${CONFIG_TABLE.MAX_ROWS_FROM_BACKEND}`;
      if (policyId) {
        apiUrl += `&filter=${policyId}`;
      }

      const response = await API.get(apiUrl);

      const mappedData = response.data.map((policy) => ({
        ...policy,
        refundDue:
          policy.status === 'PAID' || policy.status === 'REISSUE'
            ? ''
            : calculateDaysRemaining(policy.refundDueDate),
      }));

      setData(mappedData);
    } catch (error) {
      showNotification('COMMON.error.fetchingData', 'error');
      reportError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!selectedBusinessUnit || !selectedBrand) {
      showNotification('COMMON.error.noBusinessUnitSelected', 'error');
      return;
    } else if (
      selectedBusinessUnit.length === 0 ||
      selectedBrand.length === 0
    ) {
      return;
    }
    fetchData();
  }, [sessionContext]);

  return { data, fetchData };
};

export default useFetchRefundsData;
